export const SET_TOP_PANEL = 'SET_TOP_PANEL';
export const SET_THEME = 'SET_THEME';
export const SET_MY_ORDERS = 'SET_MY_ORDERS';
export const SET_ORDER_CLOSE_MODAL = 'SET_ORDER_CLOSE_MODAL';
export const OPEN_PAGE = 'OPEN_PAGE';
export const CLOSE_PAGE = 'CLOSE_PAGE';
export const SWITCH_NOTIFICATION = 'SWITCH_NOTIFICATION';
export const SWITCH_SINGIN_MODAL = 'SWITCH_SINGIN_MODAL';
export const SWITCH_SINGUP_MODAL = 'SWITCH_SINGUP_MODAL';
export const SWITCH_RESET_PASSWORD_MODAL = 'SWITCH_RESET_PASSWORD_MODAL';
export const SINGIN = 'SINGIN';
export const SINGOUT = 'SINGOUT';


// WEBPACK FOOTER //
// ./src/constants/actions.js